/* Identifica la cantidad de Sliders */

var $numberDivs = $('.container-media-wrap > .main-images').find('.image-product').length;
if ($numberDivs < 5) {
  $('.container-media-wrap > .thumbnail-images').addClass('not-scrolling-slick')
};



/* Activa Slick Slider en los productos */

$('.container-media-wrap > .main-images').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  adaptiveHeight: true,
  asNavFor: '.container-media-wrap > .thumbnail-images .thumbnail-images__slider'
});

$('.container-media-wrap > .thumbnail-images .thumbnail-images__slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.container-media-wrap > .main-images',
  dots: false,
  focusOnSelect: true,
  prevArrow: $('.thumbnail-images .thumbnail-images__prev'),
  nextArrow: $('.thumbnail-images .thumbnail-images__next'),
  vertical: true,
  verticalSwiping: true,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        dots: true,
        vertical: false,
        verticalSwiping: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        dots: true,
        vertical: false,
        verticalSwiping: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



/* Función cambio de variantes */

function $changeVariant(){
  var $variantId = $('input.product-variant-id').val();
  var $mediaId = $('.container-images-variants span.' + $variantId).attr('data-image');
  var $image = ".photo-" + $mediaId;
  var $imageVariant = $('.container-media-wrap > .thumbnail-images .image-product.slick-current').nextAll($image).eq(0);
  setTimeout(function() {
    $imageVariant.click();
  }, 300); 
};

$('input.product-variant-id').on('change', function() {
    $changeVariant();
});

$('.container-media-wrap > .main-images').on('sliderLoaded', function() {
  $changeVariant();
  $('.product__media-wrapper .container-media-wrap').animate({ opacity: 1 }, 300);
});

$('.container-media-wrap > .main-images').trigger('sliderLoaded');



/* Función Imagenes en Campo de Variante */

function imagenColorSwatch() {
  $('.product-form__input input[name="Color"]').each(function() {
    var $val = $(this).val();
    var $imagen = $('.container-images-variants span[data-option="' + $val + '"]').data("imageUrl");
    var $label = $(this).siblings("label[data-value='" + $val + "']");
    $label.prepend('<img src="' + $imagen + '">');
  });
};


$( document ).ready(function() {
    imagenColorSwatch();
});



/* Estilos Dropdown */

$(document).ready(function(){

  $('.description-product-accordion > li').first().addClass('active_description');
  $('.description-product-accordion > li > .description-product__answer').hide();
  $('.description-product-accordion > li.active_description > .description-product__answer').show();
  
  $('.description-product-accordion > li > h3').click(function() {
    var $open_description = $(this).parents('li');
    if ($($open_description).hasClass("active_description")) {
      $($open_description).removeClass("active_description").find(".description-product__answer").slideUp();
    } else {
      $(".description-product-accordion > li.active_description .description-product__answer").slideUp();
      $(".description-product-accordion > li.active_description").removeClass("active_description");
      $($open_description).addClass("active_description").find(".description-product__answer").slideDown();
    }
    return false;
  });


  $( '.product-form' ).append( $( '.form-shoppay' ) );
  
});



/* Script Okendo Stars */

function $showStarsOkendo(){
  if ($('div[data-oke-star-rating] .oke-is-clickable').length > 0) {
      console.log('Show Reviews Okendo');
  } else {
      $('div[data-oke-star-rating]').hide();
      console.log('Hide Reviews Okendo');
  };
  $observerOkendo.disconnect();
};

const $nodeOkendo = document.documentElement;
const $configOkendo = { childList: true, subtree: true };
const $observerOkendo = new MutationObserver($showStarsOkendo);

$observerOkendo.observe($nodeOkendo, $configOkendo);

